import { ChangeEvent, useEffect, useMemo, useRef, useState } from "react";
import cn from "classnames";
import styles from "./Field.module.scss";
import { IFieldProps } from "./Field.props";
import Copy from "../Copy/Copy";
import Icon from "../Icon/Icon";

import close from "@assets/icons/close.svg";
import eye from "@assets/icons/eye.svg";
import no_eye from "@assets/icons/no-eye.svg";
import decodeHTMLEntities from "@utils/decodeHTMLEntities";

export default function Field({
  label,
  // name,
  id,
  type,
  className,
  copy,
  disabled = false,
  isError = false,
  defaultValue,
  enteredValue,
  reset,
  upperCase,
  hasCleanUp,
  prefix,
  decodeHTML,
  onDelete,
  onChange,
  onGetCurrentValue,
  ...props
}: IFieldProps) {
  const ref = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState<string | number>(
    (defaultValue as string | number) ||
    (props.value as string | number) ||
    enteredValue ||
    ""
  );
  const [showPass, setShowPass] = useState<boolean>(false);

  useEffect(() => {
    if (enteredValue !== undefined) setValue(enteredValue);
  }, [enteredValue]);

  const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onChange && onChange(e);
  };

  const isPassword = type === "password";

  useEffect(() => {
    if (!ref.current) return;
    const listener = (e: MouseEvent) => {
      if (
        e.target instanceof HTMLButtonElement &&
        e.target.textContent === "Send"
      ) {
        setTimeout(() => setValue(""), 1);
      }
    };
    document.addEventListener("click", listener);
    return () => document.removeEventListener("click", listener);
  }, []);

  const onClearValue = () => {
    setValue("");
    onGetCurrentValue && onGetCurrentValue("");
  };
  //for reset
  useEffect(() => {
    if (!reset) return;
    setValue(enteredValue || defaultValue?.toString() || "");
  }, [reset]);

  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const transformed = upperCase ? value.toString().toLocaleUpperCase() : value.toString();
    if (decodeHTML) {
      setInputValue(decodeHTMLEntities(transformed));
    } else {
      setInputValue(transformed);
    }
  }, [value]);

  return (
    <div className={cn(styles.wrapper, className)}>
      <label className={styles.name}> {label ? label : props.name}</label>
      {hasCleanUp && (
        <span
          className={cn(styles.delete_text, {
            [styles.show]: !!value,
          })}
          onClick={onClearValue}
        />
      )}
      {/* <div
        className={cn(styles.inputWrapper, {
          [styles.prefix]: !!prefix,
        })}
        data-prefix={prefix}
      > */}
      <div className={styles.input}>
        <input
          className={cn({
            [styles.disabled]: disabled,
            [styles.error]: isError,
            [styles.hasValue]: !!value && hasCleanUp,
          })}
          tabIndex={disabled ? -1 : 0}
          type={showPass ? "text" : type}
          autoComplete={type === "email" ? "on" : "off"}
          //value={decodeHTMLEntities(upperCase ? value.toString().toLocaleUpperCase() : value)}
          value={inputValue}
          // defaultValue={defaultValue}
          onChange={disabled ? undefined : onChangeValue}
          onBlur={(e) =>
            type === "email"
              ? setValue((value as string).replace(/\s+/g, ""))
              : null
          }
          ref={ref}
          {...props}
        />
      </div>
      {copy && <Copy text={`${value}`} className={styles.copy} />}
      {onDelete && (
        <Icon
          src={close}
          className={styles.delete}
          onClick={onDelete}
          noHover
        />
      )}
      {isPassword && (
        <img
          className={styles.eye}
          src={showPass ? no_eye : eye}
          alt="watt manor"
          onClick={() => setShowPass(!showPass)}
        />
      )}
      {/* </div> */}
      <input value={value} id={id} hidden aria-hidden disabled />
    </div>
  );
}
